import React, { Component } from 'react';

// import AuthorityChecker from './CheckPermissions';
// TODO: 什么鬼东西，如果使用CheckPermission命名，会导致在Header中易用时检查权限失效（中断），而把这个文件命名为其他的名字时，就没有问题！！？？
// PermissionsChecker.js == CheckPermissions.js
// 升级React后又发现恢复原文件名Header权限检测正常了，但是路由权限检测出现问题（无task权限可以渲染和进入任务）了...
// 依然是使用非CheckPermissions文件名就正常...
// TODO: PermissionsChecker.js 和 CheckPermissions.js 内已经有点不一样，后期解决后统一一下；
import AuthorityChecker from './PermissionsChecker';

const RequireAuthority = WrappedComponent =>
  class HOC extends Component {
    constructor(props) {
      super(props);
      this.wrappedRef = React.createRef();
    }

    componentDidMount() {}

    render() {
      return AuthorityChecker(
        this.props.auth,
        <WrappedComponent {...this.props} ref={this.wrappedRef} />,
        this.props.noAuthView ||
          (this.props.noAuthInjectedProps ? (
            <WrappedComponent
              {...this.props}
              {...this.props.noAuthInjectedProps}
              ref={this.wrappedRef}
            />
          ) : null)
      );
    }
  };
export default RequireAuthority;
